import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import { Flag } from '@7f-ui/components/flag/flag';
import type { AccommodationFacility, AccommodationRoomFacility } from '@data-access/graphql/schema.types';
import { Barbell, BatteryCharging, BeachBall, Bicycle, CalendarBlank, Campfire, Car, Check, CigaretteSlash, Coffee, Dog, Fan, FlowerLotus, ForkKnife, Island, Martini, Plant, Storefront, ThermometerHot, Tree, UserSound, UsersFour, Waves, Wheelchair, WifiHigh } from '@phosphor-icons/react';
import type { PropsWithChildren } from 'react';
type Props = {
  facilities?: AccommodationFacility[];
  roomFacilities?: AccommodationRoomFacility[];
  className?: string;
};
export function FacilitiesList(t0) {
  const $ = _c(14);
  const {
    facilities: t1,
    roomFacilities: t2,
    className
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const facilities = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const roomFacilities = t4;
  let t5;
  if ($[4] !== className) {
    t5 = cx("flex flex-col gap-5", className);
    $[4] = className;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== facilities) {
    t6 = facilities.map(_temp);
    $[6] = facilities;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== roomFacilities) {
    t7 = roomFacilities.map(_temp2);
    $[8] = roomFacilities;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t6 || $[12] !== t7) {
    t8 = <ul className={t5}>{t6}{t7}</ul>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}
function _temp2(facility_0) {
  return <FacilityItem key={facility_0.id} id={facility_0.id} name={facility_0.name} />;
}
function _temp(facility) {
  return <FacilityItem key={facility.id} id={facility.id} name={facility.name}>{facility.extraCosts && <Flag>Zusätzliche Gebühren</Flag>}{facility.offsite && <Flag>Außerhalb der Unterkunft</Flag>}</FacilityItem>;
}
type FacilityItemProps = PropsWithChildren<{
  id: number;
  name: string;
}>;
function FacilityItem(t0) {
  const $ = _c(10);
  const {
    id,
    name,
    children
  } = t0;
  let t1;
  if ($[0] !== id) {
    t1 = <FacilityIcon facilityId={id} />;
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== name) {
    t2 = <span className="inline-block pt-0.5 sm:pt-0">{name}</span>;
    $[2] = name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = <div className="flex flex-col items-start gap-2">{t2}{children}</div>;
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <li className="grid grid-cols-[max-content_1fr] gap-4 font-body-copy">{t1}{t3}</li>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
const FACILITY_ICONS = new Map([[1, WifiHigh], [2, WifiHigh], [3, Waves], [4, Martini], [5, ForkKnife], [6, Martini], [7, CalendarBlank], [8, Wheelchair], [9, FlowerLotus], [10, Barbell], [11, Storefront], [12, Car], [13, BatteryCharging], [14, Bicycle], [15, Dog], [16, UsersFour], [17, Island], [18, CigaretteSlash], [93, Fan], [536, ThermometerHot], [537, FlowerLotus], [538, ForkKnife], [539, Tree], [540, Plant], [541, BeachBall], [542, BeachBall], [543, ForkKnife], [544, Coffee], [545, Campfire], [546, UserSound], [547, Car]]);
function FacilityIcon(t0) {
  const $ = _c(4);
  const {
    facilityId
  } = t0;
  let t1;
  if ($[0] !== facilityId) {
    t1 = FACILITY_ICONS.get(facilityId) ?? Check;
    $[0] = facilityId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const Icon = t1;
  let t2;
  if ($[2] !== Icon) {
    t2 = <Icon className="size-6" />;
    $[2] = Icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}